import "./notification-popup.scss";
import { useNavigate } from "react-router-dom";
import { calculateNotificationDuration } from "utilities/notificationduration";
import { useDispatch } from "react-redux";
import { setApplicationRoutingData } from "features/authSlice";
import { useLazyGetMyLoansByDealApplicationIdQuery } from "pages/application/applicationService";

interface NotificationProps {
  key: string | number;
  id: string;
  userId: string;
  nhDealApplicationId: string;
  title: string | undefined;
  text: string | undefined;
  link: string;
  createdOn: Date;
  onRemoveViewedNotification: (id: string) => void;
}

const Notification = ({ key, title, text, link, id, userId, nhDealApplicationId, createdOn, onRemoveViewedNotification }: NotificationProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fetchMyLoansByDealApplicationId] = useLazyGetMyLoansByDealApplicationIdQuery();
  const handleNavigation = async () => {
    try {
      const response = await fetchMyLoansByDealApplicationId({ userId, nhDealApplicationId }).unwrap();
      if (response?.length) {
        const data = response?.[0];
        dispatch(
          setApplicationRoutingData({
            nhDealApplicationId: data.nhDealApplicationId,
            nhApplicationId: data.nhDealApplicationId,
            applicationRoleType: data.applicationRoleType,
            dealApplicationId: data.dealApplicationId,
            nhApplicationStatus: data.status,
            loanId: data.loanId,
            hasPal: data.hasPal,
            prospectId: data.prospectId,
            loanPurpose: data.loanPurpose,
            leadProvider: data.leadProvider,
            borrowerConsentStatus: data.borrowerConsentStatus,
            coBorrowerConsentStatus: data.coBorrowerConsentStatus,
            userRole: data.userRole,
            inquiryId: data.inquiryId,
          })
        );
        navigate(`${link}&Id=${id}`, { replace: true });
        onRemoveViewedNotification(id);
      }
    } catch (error) {
      console.error("Error fetching deal application data:", error);
    }
  };

  return (
    <div className="notifiy-popup-wrapper" key={key}>
      <span className="notifiy-popup-wrapper__section">{title}</span>
      <span className="notifiy-popup-wrapper__name">{text}</span>
      <div className="notifiy-popup-wrapper__navigation">
        <span>{calculateNotificationDuration(createdOn)}</span>
        <button className="notifiy-popup-wrapper__navigation--link-btn" onClick={handleNavigation}>
          View
        </button>
      </div>
    </div>
  );
};

export default Notification;
